import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function EventDetailModalSlider() {
  var swiper;
  var slideIndex = 0;

  function initializeSwiper() {
    swiper = new Swiper(".js-event-detail-modal-slider", {
      lazy: true,
      slidesPerView: 1,
      initialSlide: slideIndex,
      pagination: {
        el: ".js-event-detail-modal-slider-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-event-detail-modal-slider-next",
        prevEl: ".js-event-detail-modal-slider-prev",
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });
  }

  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  function handleResize() {
    var slideCount = $(".js-event-detail-modal-slider").find(".swiper-slide").length;

    if (slideCount === 1) {
      destroySwiper();
      $(".js-event-detail-modal-slider-control").hide();
    } else {
      if (!swiper) {
        initializeSwiper();
      }
    }
  }

  $(document).on("click", ".js-event-detail-modal-trigger", function () {
    destroySwiper();

    var parentSlide = $(this).closest(".swiper-slide");
    slideIndex = parentSlide.data("swiper-slide-index");

    initializeSwiper();
    handleResize();
  });
}

export { EventDetailModalSlider };
